import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import theme from '../../assets/theme';
import { useRawGame } from '../../hooks/useGame';
import { getConfig } from '../../utils/store';
import { zIndexes } from '../../utils/zIndexes';
import { Button } from '../_atoms/Button';

export const PinCodeNudger = ({
  gameId,
  onPinClick,
  backgroundBrightness,
}: {
  gameId: string;
  onPinClick?: () => void;
  backgroundBrightness?: number | null;
}) => {
  const url = getConfig().game.url;
  const { t } = useTranslation('Host');

  const { data: game } = useRawGame(gameId);
  const pinCode = game?.pin;
  return (
    <UrlAndPinContainer
      onClick={() => onPinClick && onPinClick()}
      $cursor={!!onPinClick ? 'pointer' : 'default'}
      id={'url-and-pin-container'}
    >
      {!!onPinClick && !!pinCode && (
        <UrlHoverModal id="url-hover-modal">
          <UrlHoverModalSpan>
            <span style={{ textAlign: 'center' }}>
              {' '}
              <strong>{url.toLowerCase()}</strong>
            </span>
            <UrlHoverModalSpanPin>pin: {pinCode}</UrlHoverModalSpanPin>
            <UrlHoverPinButton type="ghost">{t('Open join screen')}</UrlHoverPinButton>
          </UrlHoverModalSpan>
        </UrlHoverModal>
      )}
      <span
        style={{
          color: backgroundBrightness && backgroundBrightness < 0.5 ? 'white' : undefined,
          fontSize: 40,
        }}
      >
        {t('Join at')}
        <strong> {url.toLowerCase()} </strong>
        {t('with pin')}: <strong>{pinCode ? pinCode : ''}</strong>
      </span>
    </UrlAndPinContainer>
  );
};
export const UrlHoverModalSpanPin = styled.span`
  font-size: 48px;
`;

export const UrlHoverPinButton = styled(Button)`
  color: white;
  border-radius: 10px;
  border-color: white;
  &:hover {
    background-color: ${theme.colors.greyDark};
  }
  &:hover,
  &:focus {
    color: white;
    border-color: white;
  }
`;

export const UrlHoverModal = styled.div`
  position: absolute;
  top: 0;
  transform: translateY(-100%);
  background-color: ${theme.colors.black};
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
  width: 50%;
  color: white;
  display: flex;
  padding: 10px;
  opacity: 0;
  border-radius: 10px;
  transition: 1s;
`;

export const UrlHoverModalSpan = styled.span`
  display: grid;
  width: 100%;
  justify-content: center;
  justify-items: center;
  grid-auto-flow: row;
  font-size: 36px;
`;

const UrlAndPinContainer = styled.div<{ $cursor: string }>`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: ${zIndexes('WYSIWYF_PIN_CODE')};
  border-radius: 5px 5px;
  display: flex;
  cursor: ${({ $cursor }) => $cursor};
  justify-content: center;
  align-items: center;
  opacity: 0.7;

  color: ${theme.colors.black};
  &:hover #url-hover-modal {
    opacity: 1;
    transform: translateY(2%);
  }
  &:hover {
    opacity: 1;
  }

  @media (max-width: 800px) {
    width: 95%;
  }
`;
